<div class="card card-hover h-100 rounded-1 overflow-hidden bg-white">
  <div class="card-body d-flex align-items-center h-100 gap-3">
    <div class="d-flex align-items-center">
      <img
        [src]="imageUrl ?? fallbackImageUrl"
        [alt]="result.id"
        (error)="imageUrl = fallbackImageUrl"
        class="rounded p-2">
    </div>
    <div class="flex-grow-1">
      <a
        [appSearchResultLink]="result"
        [href]="result.url"
        class="fw-bold text-truncate-2 text-decoration-none text-gray-800 stretched-link">{{ result.title }}</a>
      <div
        class="small text-truncate-2 text-gray-500 text-break"
        [title]="result.synopsis">{{ result.synopsis }}
      </div>
    </div>
  </div>
</div>
